import { CatalogMetadata } from "./catalog-metadata.model";
import { CatalogScope } from "./catalog-scope.enum";

export class TemperatureDerationCatalog {
    public constructor(init?: Partial<TemperatureDerationCatalog>) {
        Object.assign(this, init);
        this.metadata = init && init.metadata ? new CatalogMetadata(init.metadata) : null;
    }

    id: string;
    name: string;
    temperatureDerationProfile: {
        temperature: number,
        derationFactor: number
    }[];
    isLocked: boolean;
    metadata: CatalogMetadata;
    scope: CatalogScope;
}

export class TemperatureDerationLookupResult {
    public constructor(init?: Partial<TemperatureDerationLookupResult>) {
        Object.assign(this, init);
        this.metadata = init && init.metadata ? new CatalogMetadata(init.metadata) : null;
    }

    id: string;
    name: string;
    temperatureDerationProfile: {
        temperature: number,
        derationFactor: number
    }[];
    isLocked: boolean;
    metadata: CatalogMetadata;
    scope: CatalogScope;
}